import { Navigate, Outlet } from 'react-router-dom';
import Loader from 'components/loader/Loader';
import useHostfullyAccounting from 'hooks/hostfullyAccounting/useHostfullyAccounting';

const HostfullyAccounting = () => {
  const { isAccountingEligible, isLoading } = useHostfullyAccounting();

  if (isLoading) {
    return <Loader />;
  }

  if (!isAccountingEligible) {
    return <Navigate to="/integrations" replace />;
  }

  return <Outlet />;
};

export default HostfullyAccounting;
